module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero_wrapper"
  }, [_c('div', {
    staticClass: "rev_slider gradient_slider",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "hero"
    }
  }, [_c('ul', [_c('li', {
    attrs: {
      "data-index": "rs-214",
      "data-delay": "1000",
      "data-transition": "fade",
      "data-slotamount": "7",
      "data-easein": "default",
      "data-easeout": "default",
      "data-masterspeed": "100",
      "data-rotate": "0",
      "data-x": "0",
      "data-saveperformance": "off",
      "data-title": "Slide",
      "data-description": ""
    }
  }, [_c('img', {
    staticClass: "rev-slidebg",
    attrs: {
      "src": "/assets/images/slider/hero.jpg",
      "alt": "Image",
      "data-bgposition": "center center",
      "data-bgfit": "cover",
      "data-bgrepeat": "no-repeat",
      "data-bgparallax": "5",
      "data-no-retina": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tp-caption",
    staticStyle: {
      "color": "#fff",
      "font-weight": "700",
      "font-family": "'Raleway', sans-serif"
    },
    attrs: {
      "data-x": "['left','left','left','center']",
      "data-hoffset": "['15','15','15','0']",
      "data-y": "['190','200','200','200']",
      "data-responsive_offset": "on",
      "data-fontsize": "['40','28','28','22']",
      "data-lineheight": "['40','28','28','22']",
      "data-whitespace": "nowrap",
      "data-frames": "[{\"delay\":0,\"speed\":1500,\"frame\":\"0\",\"from\":\"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;\",\"mask\":\"x:0px;y:[100%];s:inherit;e:inherit;\",\"to\":\"o:1;\",\"ease\":\"Power2.easeInOut\"},{\"delay\":\"wait\",\"speed\":300,\"frame\":\"999\",\"to\":\"auto:auto;\",\"ease\":\"Power3.easeInOut\"}]"
    }
  }, [_vm._v("WELCOME TO ZANTE, "), _c('span', {
    attrs: {
      "id": "text_rotating"
    }
  }, [_vm._v("LIVE YOUR MYTH, MODERN ROOMS, GREEK CUISINE")])]), _vm._v(" "), _c('div', {
    staticClass: "tp-caption tp_m_title",
    attrs: {
      "data-visibility": "['on','on','off','off']",
      "data-x": "['left','left','left','left']",
      "data-hoffset": "['15','15','15','15']",
      "data-y": "['280','middle','middle','middle']",
      "data-voffset": "['-60','-60','-60','-60']",
      "data-fontsize": "['28','28','23','23']",
      "data-lineheight": "['28','28','23','23']",
      "data-frames": "[{\"delay\":1000,\"speed\":1500,\"frame\":\"0\",\"from\":\"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;\",\"mask\":\"x:0px;y:[100%];s:inherit;e:inherit;\",\"to\":\"o:1;\",\"ease\":\"Power2.easeInOut\"}]"
    }
  }, [_c('i', {
    staticClass: "fa fa-star-o"
  })]), _vm._v(" "), _c('div', {
    staticClass: "tp-caption tp_m_title",
    attrs: {
      "data-visibility": "['on','on','off','off']",
      "data-x": "['left','left','left','left']",
      "data-hoffset": "['55','45','45','45']",
      "data-y": "['280','middle','middle','middle']",
      "data-voffset": "['-60','-60','-60','-60']",
      "data-responsive_offset": "on",
      "data-fontsize": "['28','28','23','23']",
      "data-lineheight": "['28','28','23','23']",
      "data-frames": "[{\"delay\":1150,\"speed\":1500,\"frame\":\"0\",\"from\":\"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;\",\"mask\":\"x:0px;y:[100%];s:inherit;e:inherit;\",\"to\":\"o:1;\",\"ease\":\"Power2.easeInOut\"}]"
    }
  }, [_c('i', {
    staticClass: "fa fa-star-o"
  })]), _vm._v(" "), _c('div', {
    staticClass: "tp-caption tp_m_title",
    attrs: {
      "data-visibility": "['on','on','off','off']",
      "data-x": "['left','left','left','left']",
      "data-hoffset": "['95','75','75','75']",
      "data-y": "['280','middle','middle','middle']",
      "data-voffset": "['-60','-60','-60','-60']",
      "data-responsive_offset": "on",
      "data-fontsize": "['28','28','23','23']",
      "data-lineheight": "['28','28','23','23']",
      "data-frames": "[{\"delay\":1300,\"speed\":1500,\"frame\":\"0\",\"from\":\"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;\",\"mask\":\"x:0px;y:[100%];s:inherit;e:inherit;\",\"to\":\"o:1;\",\"ease\":\"Power2.easeInOut\"}]"
    }
  }, [_c('i', {
    staticClass: "fa fa-star-o"
  })]), _vm._v(" "), _c('div', {
    staticClass: "tp-caption tp_m_title",
    attrs: {
      "data-visibility": "['on','on','off','off']",
      "data-x": "['left','left','left','left']",
      "data-hoffset": "['135','105','105','105']",
      "data-y": "['280','middle','middle','middle']",
      "data-voffset": "['-60','-60','-60','-60']",
      "data-responsive_offset": "on",
      "data-fontsize": "['28','28','23','23']",
      "data-lineheight": "['28','28','23','23']",
      "data-frames": "[{\"delay\":1450,\"speed\":1500,\"frame\":\"0\",\"from\":\"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;\",\"mask\":\"x:0px;y:[100%];s:inherit;e:inherit;\",\"to\":\"o:1;\",\"ease\":\"Power2.easeInOut\"}]"
    }
  }, [_c('i', {
    staticClass: "fa fa-star-o"
  })]), _vm._v(" "), _c('div', {
    staticClass: "tp-caption tp_m_title",
    attrs: {
      "data-visibility": "['on','on','off','off']",
      "data-x": "['left','left','left','left']",
      "data-hoffset": "['175','135','135','135']",
      "data-y": "['280','middle','middle','middle']",
      "data-voffset": "['-60','-60','-60','-60']",
      "data-responsive_offset": "on",
      "data-fontsize": "['28','28','23','23']",
      "data-lineheight": "['28','28','23','23']",
      "data-frames": "[{\"delay\":1600,\"speed\":1500,\"frame\":\"0\",\"from\":\"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;\",\"mask\":\"x:0px;y:[100%];s:inherit;e:inherit;\",\"to\":\"o:1;\",\"ease\":\"Power2.easeInOut\"}]"
    }
  }, [_c('i', {
    staticClass: "fa fa-star-o"
  })]), _vm._v(" "), _c('div', {
    staticClass: "tp-caption tp_m_title",
    attrs: {
      "data-visibility": "['on','on','off','off']",
      "data-x": "left",
      "data-hoffset": "['215','175','175','175']",
      "data-y": "['280','middle','middle','middle']",
      "data-voffset": "['-60','-60','-60','-60']",
      "data-responsive_offset": "on",
      "data-fontsize": "['30','30','25','25']",
      "data-lineheight": "['30','30','25','25']",
      "data-frames": "[{\"delay\":1750,\"speed\":1500,\"frame\":\"0\",\"from\":\"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;\",\"mask\":\"x:0px;y:[100%];s:inherit;e:inherit;\",\"to\":\"o:1;\",\"ease\":\"Power2.easeInOut\"}]"
    }
  }, [_vm._v("Star Luxury Hotel\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "tp-caption tp_s_title",
    attrs: {
      "data-visibility": "['on','on','on','off']",
      "data-x": "['left','left','left','left']",
      "data-hoffset": "['15','15','15','15']",
      "data-y": "['350','middle','top','top']",
      "data-voffset": "['50','50','300','300']",
      "data-responsive_offset": "on",
      "data-fontsize": "['20','20','20','15']",
      "data-lineheight": "['20','20','20','15']",
      "data-frames": "[{\"delay\":2000,\"speed\":1500,\"frame\":\"0\",\"from\":\"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;\",\"mask\":\"x:0px;y:[100%];s:inherit;e:inherit;\",\"to\":\"o:1;\",\"ease\":\"Power2.easeInOut\"}]"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square-o"
  }), _vm._v(" Modern Rooms & Spacious Suites\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "tp-caption tp_s_title",
    attrs: {
      "data-visibility": "['on','on','on','off']",
      "data-x": "['left','left','left','left']",
      "data-hoffset": "['15','15','15','15']",
      "data-y": "['400','middle','top','top']",
      "data-voffset": "['80','100','350','350']",
      "data-responsive_offset": "on",
      "data-fontsize": "['20','20','20','15']",
      "data-lineheight": "['20','20','20','15']",
      "data-frames": "[{\"delay\":2200,\"speed\":1500,\"frame\":\"0\",\"from\":\"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;\",\"mask\":\"x:0px;y:[100%];s:inherit;e:inherit;\",\"to\":\"o:1;\",\"ease\":\"Power2.easeInOut\"}]"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square-o"
  }), _vm._v(" A Gourmet Dining Experience\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "tp-caption tp_s_title",
    attrs: {
      "data-visibility": "['on','on','on','off']",
      "data-x": "['left','left','left','left']",
      "data-hoffset": "['15','15','15','15']",
      "data-y": "['450','middle','top','top']",
      "data-voffset": "['110','150','400','400']",
      "data-responsive_offset": "on",
      "data-fontsize": "['20','20','20','15']",
      "data-lineheight": "['20','20','20','15']",
      "data-frames": "[{\"delay\":2400,\"speed\":1500,\"frame\":\"0\",\"from\":\"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;\",\"mask\":\"x:0px;y:[100%];s:inherit;e:inherit;\",\"to\":\"o:1;\",\"ease\":\"Power2.easeInOut\"}]"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square-o"
  }), _vm._v(" Family Room from €89 per night\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "tp-caption f_item",
    attrs: {
      "data-visibility": "['on','off','off','off']",
      "data-x": "['left','left','left','left']",
      "data-hoffset": "['15','15','15','15']",
      "data-y": "['610','610','610','610']",
      "data-voffset": "",
      "data-responsive_offset": "on",
      "data-frames": "[{\"delay\":3000,\"speed\":1500,\"frame\":\"0\",\"from\":\"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;\",\"mask\":\"x:0px;y:[100%];s:inherit;e:inherit;\",\"to\":\"o:1;\",\"ease\":\"Power2.easeInOut\"}]"
    }
  }, [_c('div', {
    staticClass: "icon_box"
  }, [_c('i', {
    staticClass: "fa fa-wifi"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text_box"
  }, [_vm._v("\n                        ENJOY FREE WI-FI\n                        "), _c('span', [_vm._v("IN THE WHOLE HOTEL")])])]), _vm._v(" "), _c('div', {
    staticClass: "tp-caption f_item",
    attrs: {
      "data-visibility": "['on','off','off','off']",
      "data-x": "['left','left','left','left']",
      "data-hoffset": "['265','265','265','265']",
      "data-y": "['610','610','610','610']",
      "data-voffset": "",
      "data-responsive_offset": "on",
      "data-frames": "[{\"delay\":3000,\"speed\":1500,\"frame\":\"0\",\"from\":\"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;\",\"mask\":\"x:0px;y:[100%];s:inherit;e:inherit;\",\"to\":\"o:1;\",\"ease\":\"Power2.easeInOut\"}]"
    }
  }, [_c('div', {
    staticClass: "icon_box"
  }, [_c('i', {
    staticClass: "fa fa-television"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text_box"
  }, [_vm._v("\n                        CABLE TELEVISION\n                        "), _c('span', [_vm._v("FREE CABLE TV")])])]), _vm._v(" "), _c('div', {
    staticClass: "tp-caption f_item",
    attrs: {
      "data-visibility": "['on','off','off','off']",
      "data-x": "['left','left','none','left']",
      "data-hoffset": "['515','515','515','515']",
      "data-y": "['610','610','610','610']",
      "data-voffset": "",
      "data-responsive_offset": "on",
      "data-frames": "[{\"delay\":3000,\"speed\":1500,\"frame\":\"0\",\"from\":\"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;\",\"mask\":\"x:0px;y:[100%];s:inherit;e:inherit;\",\"to\":\"o:1;\",\"ease\":\"Power2.easeInOut\"}]"
    }
  }, [_c('div', {
    staticClass: "icon_box"
  }, [_c('i', {
    staticClass: "flaticon-tool"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text_box"
  }, [_vm._v("\n                        RESTAURANT\n                        "), _c('span', [_vm._v("BAR & RESTAURANT")])])]), _vm._v(" "), _c('div', {
    staticClass: "tp-caption",
    staticStyle: {
      "z-index": "99"
    },
    attrs: {
      "data-x": "['right','right','center','center']",
      "data-hoffset": "['15','15','0','0']",
      "data-y": "['200','160','500','400']",
      "data-width": "[368, 368, 768, 480]",
      "data-height": "[auto, auto, auto, auto]",
      "data-frames": "[{\"delay\":3000,\"speed\":1500,\"frame\":\"0\",\"from\":\"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;\",\"mask\":\"x:0px;y:[100%];s:inherit;e:inherit;\",\"to\":\"o:1;\",\"ease\":\"Power2.easeInOut\"}]"
    }
  }, [_c('div', {
    staticClass: "vbf"
  }, [_c('h2', {
    staticClass: "form_title"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" BOOK ONLINE")]), _vm._v(" "), _c('form', {
    staticClass: "inner",
    attrs: {
      "id": "booking-form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "name": "booking-name",
      "placeholder": "Enter Your Name",
      "type": "text"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "name": "booking-email",
      "placeholder": "Enter Your Email Address",
      "type": "email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "name": "booking-phone",
      "placeholder": "Enter Your Phone Number",
      "type": "text"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form_select"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "booking-roomtype",
      "title": "Select Room Type",
      "data-header": "Room Type"
    }
  }, [_c('option', {
    attrs: {
      "value": "Single Room"
    }
  }, [_vm._v("Single Room")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Double Room"
    }
  }, [_vm._v("Double Room")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Deluxe Room"
    }
  }, [_vm._v("Deluxe Room")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 col-sm-6 col-xs-12 nopadding"
  }, [_c('div', {
    staticClass: "form_select"
  }, [_c('select', {
    staticClass: "form-control md_noborder_right",
    attrs: {
      "name": "booking-adults",
      "title": "Adults",
      "data-header": "Adults"
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 col-sm-6 col-xs-12 nopadding"
  }, [_c('div', {
    staticClass: "form_select"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "booking-children",
      "title": "Children",
      "data-header": "Children"
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 col-sm-6 col-xs-12 nopadding"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "form_date"
  }, [_c('input', {
    staticClass: "datepicker form-control md_noborder_right",
    attrs: {
      "type": "text",
      "name": "booking-checkin",
      "placeholder": "Arrival Date",
      "readonly": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 col-sm-6 col-xs-12 nopadding"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "form_date"
  }, [_c('input', {
    staticClass: "datepicker form-control",
    attrs: {
      "type": "text",
      "name": "booking-checkout",
      "placeholder": "Departure Date",
      "readonly": ""
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "button btn_lg btn_blue btn_full",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("BOOK A ROOM NOW")]), _vm._v(" "), _c('div', {
    staticClass: "a_center mt10"
  }, [_c('a', {
    staticClass: "a_b_f",
    attrs: {
      "href": "booking-form.html"
    }
  }, [_vm._v("Advanced Booking Form")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tp-caption",
    staticStyle: {
      "z-index": "11",
      "white-space": "nowrap",
      "font-size": "22px",
      "line-height": "30px",
      "font-weight": "400",
      "color": "rgba(245, 245, 245, 1.00)",
      "text-transform": "left",
      "cursor": "pointer"
    },
    attrs: {
      "data-visibility": "['on','on','off','off']",
      "data-x": "['center','center','center','center']",
      "data-hoffset": "['0','0','0','0']",
      "data-y": "['bottom','bottom','bottom','bottom']",
      "data-voffset": "['20','20','20','20']",
      "data-width": "none",
      "data-height": "none",
      "data-whitespace": "nowrap",
      "data-transform_idle": "o:1;",
      "data-transform_in": "opacity:0;s:500;e:Power2.easeInOut;",
      "data-transform_out": "opacity:0;s:300;s:300;",
      "data-start": "8000",
      "data-splitin": "none",
      "data-splitout": "none",
      "data-actions": "[{\"event\":\"click\",\"action\":\"scrollbelow\",\"offset\":\"px\"}]",
      "data-responsive_offset": "on",
      "data-startslide": "0",
      "data-endslide": "2"
    }
  }, [_c('div', {
    staticClass: "rs-looped rs-slideloop",
    attrs: {
      "data-easing": "Power2.easeInOut",
      "data-speed": "1",
      "data-xs": "0",
      "data-xe": "0",
      "data-ys": "-5",
      "data-ye": "5"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6da9eede"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider/Slider.vue
// module id = 379
// module chunks = 0